import { useEclipseAiContent } from '../hooks/useEclipseAiContent';

/**
 * Mounts above the routed page tree to fire the AI plan-content query as
 * early as possible — so the slow (~2-3s) wixAIGateway LLM call is already
 * in flight (ideally resolved) by the time `SelectPlan` renders and
 * `ProductDescription` reads it. Same request shape as the call inside
 * `useProductDescription` → `useEclipseAiContent`, so react-query dedupes:
 * only one network request fires per session.
 *
 * Internally gated on the `eclipseAiPlanCopy` experiment — `useEclipseAiContent`
 * doesn't fire the query when it's off — so control-group users never hit the
 * endpoint.
 *
 * Renders nothing. Must be mounted inside `<ApisClientProvider>` and after the
 * p3Context has been set on the eclipse offering context (i.e. inside the
 * module Provider's return tree).
 */
export const AiContentPrefetch = () => {
  useEclipseAiContent();
  return null;
};
//# sourceMappingURL=AiContentPrefetch.js.map